<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M4.965 8.092a11.361 11.361 0 0 0 4.943 4.943l1.65-1.65a.746.746 0 0 1 .764-.18c.84.277 1.748.428 2.678.428.412 0 .75.337.75.75V15c0 .412-.338.75-.75.75C7.957 15.75 2.25 10.043 2.25 3c0-.413.337-.75.75-.75h2.625c.412 0 .75.337.75.75 0 .938.15 1.838.428 2.678a.753.753 0 0 1-.188.764l-1.65 1.65Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
